<div class="card-header">  {{user.name | translatedb }} </div>
<div class="team-user-container">
  <div class="team-user-left-part">
    <img class="team-user-picture" src="{{user.picture}}" alt="user picture">
    <div class="team-user-work-position" [innerHTML]="user.workPosition | translatedb"></div>
  </div>
  <div class="team-user-right-part">
    <div class="team-user-birthdate-field all-fields" *ngIf="user.birthdate">
      <div class="team-user-birthdate-text all-texts">
        {{ 'BIRTH_DATE' | translate | lowercase}}:
      </div>
      <div class="team-user-birthdate-value all-values">
        {{user.birthdate}} год.
      </div>
    </div>
    <div class="team-user-education-field all-fields" *ngIf="user.education.value">
      <div class="team-user-education-text all-texts">
        {{ 'EDUCATION' | translate | lowercase}}:
      </div>
      <div class="team-user-education-value all-values" [innerHTML]="user.education | translatedb">
      </div>
    </div>
    <div class="team-user-spoken-languages-field all-fields" *ngIf="user.spokenLanguages.value">
      <div class="team-user-spoken-languages-text all-texts">
        {{ 'SPOKEN_LANGUAGES' | translate | lowercase}}:
      </div>
      <div class="team-user-spoken-languages-value all-values">
        {{user.spokenLanguages | translatedb}}
      </div>
    </div>
    <div class="team-user-additional-qualifications-field all-fields" *ngIf="user.additionalQualifications.value">
      <div class="team-user-additional-qualifications-text all-texts">
        {{ 'ADDITIONAL_QUALIFICATIONS' | translate | lowercase}}:
      </div>
      <div class="team-user-additional-qualifications-value all-values"
           [innerHTML]="user.additionalQualifications | translatedb">
      </div>
    </div>
    <div class="team-user-working-from-field all-fields" *ngIf="user.workingFrom">
      <div class="team-user-working-from-text all-texts">
        {{ 'WORKING_IN_REAL_ESTATE' | translate | lowercase}}:
      </div>
      <div class="team-user-working-from-value all-values">
        <br> {{ 'FROM' | translate | lowercase}} {{user.workingFrom}} год.
      </div>
    </div>
    <div class="team-user-interests-qualifications-field all-fields" *ngIf="user.interests.value">
      <div class="team-user-interests-qualifications-text all-texts">
        {{ 'INTERESTS' | translate | lowercase}}:
      </div>
      <div class="team-user-interests-qualifications-value all-values" [innerHTML]="user.interests | translatedb">
      </div>
    </div>
  </div>
</div>
